import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useWarehouse, useUpdateWarehouse } from "../hooks";
import { WarehouseForm } from "../components";

type IUpdateWarehouse = {
  id: string;
};

export const UpdateWarehouse: React.FC = () => {
  const { id } = useParams<IUpdateWarehouse>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useWarehouse(+id!);
  const { form, submit, loading } = useUpdateWarehouse({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("L'entrepôt a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.warehouse?.ok && data?.warehouse?.result) {
      const { result } = data.warehouse;
      form.setValue("name", result.name);
      form.setValue("address", result.address);
      form.setValue("active", result.active);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Entrepôt"
        subtitle={data?.warehouse?.result?.name}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/warehouse/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un entrepôt" />
          <WarehouseForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
